<template>
  <div class="grid grid-cols-2 gap-8">
    <!-- The span belongs to the grid item; on `PhotoFrame`'s root it leaks into any
             parent grid. -->
    <div
      v-for="(photo, index) in photos"
      :key="index"
      :class="{ 'col-span-2': photo.orientation === 'horizontal' }"
    >
      <PhotoFrame :photo />
    </div>
  </div>
</template>

<script setup lang="ts">
import PhotoFrame from '~/scopes/campaign/components/highlights/metal/PhotoFrame.vue'
import type { MetalPhoto } from '~/scopes/campaign/data/metals/types'

// Orientation is the layout: a vertical takes one cell, a horizontal spans both, and
// auto-placement packs the rest. Two columns at every width — one column is not a bento.
defineProps<{ photos: readonly MetalPhoto[] }>()
</script>
